export { NetworkedResources as ResourcesScreen } from './components/NetworkedResources';
